/* NB-015-DI */
(function () {
  if (window.__nbUpcartGiftGuardInstalled) return;
  window.__nbUpcartGiftGuardInstalled = true;

  // UpCart is the cart on this store. Native /cart is a layout-none bounce
  // (templates/cart.liquid). This script opens the slider after that bounce
  // and strips orphaned gifts. Never open UpCart by clicking a[href="/cart"].
  var SS_OPEN_UPCART = 'nb_upcart_gift_guard_open';
  var HASH_OPEN_UPCART = '#nb-open-upcart';

  function readConfig() {
    var el = document.getElementById('nb-upcart-gift-guard-config');
    if (!el) return { qualifyingProductIds: [] };
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return { qualifyingProductIds: [] };
    }
  }

  function normId(id) {
    var n = typeof id === 'string' ? parseInt(id, 10) : Number(id);
    return n > 0 && !isNaN(n) ? n : null;
  }

  function toSet(list) {
    var set = {};
    (list || []).forEach(function (id) {
      var n = normId(id);
      if (n) set[n] = true;
    });
    return set;
  }

  var qualifyingProductSet = toSet(readConfig().qualifyingProductIds);

  function isGiftLineItem(item) {
    return !!(item && item.properties && item.properties.__upcartFreeGift === 'true');
  }

  function hasQualifyingProduct(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(function (item) {
      if (!item || isGiftLineItem(item)) return false;
      var pid = normId(item.product_id);
      return pid && qualifyingProductSet[pid];
    });
  }

  function openUpCart() {
    if (typeof window.upcartOpenCart === 'function') {
      window.upcartOpenCart();
      return true;
    }

    var fab = document.querySelector('#upcart-fab, .upcart-fab');
    if (fab) {
      fab.click();
      return true;
    }

    return false;
  }

  function isNativeCartPath() {
    var path = (window.location.pathname || '').replace(/\/+$/, '') || '/';
    return path === '/cart' || /\/cart$/.test(path);
  }

  function consumeOpenFlag() {
    var flagged = false;
    try {
      flagged = sessionStorage.getItem(SS_OPEN_UPCART) === '1';
      if (flagged) sessionStorage.removeItem(SS_OPEN_UPCART);
    } catch (e) {}

    if (window.location.hash === HASH_OPEN_UPCART) {
      flagged = true;
      if (history.replaceState) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }

    return flagged;
  }

  function runOrphanGiftCleanup() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;
        if (hasQualifyingProduct(cart)) return;

        var updates = {};
        cart.items.forEach(function (item) {
          if (item && isGiftLineItem(item) && item.key) updates[item.key] = 0;
        });
        if (!Object.keys(updates).length) return;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates }),
        });
      })
      .catch(function () {});
  }

  function redirectToStorefront() {
    try {
      sessionStorage.setItem(SS_OPEN_UPCART, '1');
    } catch (e) {}
    window.location.replace('/' + HASH_OPEN_UPCART);
  }

  function openUpCartFromFlag() {
    if (!consumeOpenFlag()) return;

    runOrphanGiftCleanup();

    (function tryOpen(attempt) {
      if (openUpCart() || attempt >= 24) return;
      setTimeout(function () {
        tryOpen(attempt + 1);
      }, 250);
    })(0);
  }

  function guardNativeCart() {
    document.documentElement.classList.add('nb-upcart-gift-guard-redirecting');
    runOrphanGiftCleanup();
    redirectToStorefront();
  }

  function wire() {
    if (isNativeCartPath()) {
      guardNativeCart();
      return;
    }
    openUpCartFromFlag();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();
